import React from "react";
import LoginForm from "./components/loginForm";
import contratList from "./components/contratList";
import ContraDetails from "./components/contraDetails"
import ListOfActions from "./components/listOfActions";
import CreateAction from "./components/createAction";
import CreateKpis from "./components/createKpis";

import {
    BrowserRouter as Router,
    Switch,
    Route
} from "react-router-dom";
import ActionDetails from "./components/actionDetails";

function App() {
  return (
      <Router>
          <Switch>
              <Route exact path='/' component={LoginForm}/>
              <Route exact path='/listContra' component={contratList}/>
              <Route exact path='/contraDetails' component={ContraDetails}/>
              <Route exact path='/listOfAction' component={ListOfActions}/>
              <Route exact path='/createAction' component={CreateAction}/>
              <Route exact path='/createKpis' component={CreateKpis}/>
              <Route exact path='/actionDetails' component={ActionDetails}/>
          </Switch>
      </Router>
  );
}

export default App;
